document.addEventListener('DOMContentLoaded', function () {
  if (window.location.hash) {
    const id = window.location.hash.substring(1);
    if (id) {
      const targetElem = document.getElementById(id);
      if (targetElem) {
        targetElem.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    }
  }
});